import { render, staticRenderFns } from "./ZertifikatPDFModal.vue?vue&type=template&id=6f0073ad&"
import script from "./ZertifikatPDFModal.vue?vue&type=script&lang=js&"
export * from "./ZertifikatPDFModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports